import { lazy } from 'react'

// Mapping & Onboarding
const Mapping = lazy(() => import('src/pages/members/Mapping/Mapping'))
const OnboardStatus = lazy(() => import('src/pages/members/OnboardStatus/OnboardStatus'))


export const onboardRoutes = [
  {
    path: 'onboard',
    children: [
      { path: 'data', element: <Mapping /> }, // New canonical path: /onboard/data
      { path: 'status', element: <OnboardStatus /> }, // New canonical path: /onboard/status
      { path: 'store-mapping', element: <Mapping /> } // New canonical path: /onboard/store-mapping
    ]
  }
]
